import {TItemValidateForm} from './core/model/sale'

export const buildUserRequest = (data: TItemValidateForm) => {
  const items = data.seller.map((seller, index) => ({
    item: data.product[index],
    seller: Number(seller.value),
  }))

  return items
}
